"use client";

export function RevvaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="176"
      height="32"
      viewBox="0 0 176 32"
      fill="none"
    >
      <path
        d="M18.2205 32V0H32.0425C34.4191 0 36.4987 0.467348 38.2812 1.40205C40.0637 2.33674 41.45 3.65051 42.4403 5.34335C43.4306 7.03618 43.9257 9.01462 43.9257 11.2787C43.9257 13.5635 43.4149 15.5419 42.3934 17.214C41.3823 18.8861 39.9594 20.1739 38.1248 21.0774C36.3006 21.9809 34.169 22.4327 31.7298 22.4327H23.4741V15.7029H29.9786C31.0001 15.7029 31.8705 15.5263 32.5898 15.1732C33.3194 14.8097 33.8771 14.2957 34.2628 13.631C34.6589 12.9663 34.8569 12.1822 34.8569 11.2787C34.8569 10.3647 34.6589 9.58583 34.2628 8.94193C33.8771 8.28764 33.3194 7.78913 32.5898 7.44641C31.8705 7.09331 31.0001 6.91675 29.9786 6.91675H26.914V32H18.2205Z"
        fill="#044752"
      />
      <path
        d="M10.7781 20.2693C12.7861 19.4831 14.3874 18.2507 15.5804 16.5663C16.7719 14.8818 17.3677 12.9328 17.3677 10.713C17.3677 7.64655 16.3122 5.09569 14.1984 3.05892C12.0845 1.01914 9.43534 0 6.2494 0H0V6.77106H6.09214C7.20805 6.77106 8.13646 7.15664 8.87738 7.92629C9.61527 8.69593 9.98724 9.65459 9.98724 10.8038C9.98724 11.9529 9.61376 12.8844 8.86679 13.6449C8.11983 14.4085 7.19444 14.7881 6.09365 14.7881H0V21.0617H3.03473L9.62434 32H18.2537L10.7796 20.2693H10.7781Z"
        fill="#CB9A2B"
      />
      <path
        d="M169.619 27.6523C169.349 28.3544 169.088 28.9755 168.836 29.5156C168.584 30.0557 168.26 30.5058 167.864 30.8658C167.486 31.2439 167 31.5229 166.406 31.7029C165.812 31.901 165.029 32 164.057 32C163.012 32 162.004 31.838 161.032 31.5139L161.572 28.1924C162.184 28.4624 162.814 28.5975 163.462 28.5975C163.913 28.5975 164.282 28.5435 164.57 28.4354C164.858 28.3454 165.092 28.2014 165.272 28.0034C165.47 27.8233 165.632 27.5983 165.758 27.3283C165.884 27.0582 166.019 26.7432 166.163 26.3831L166.46 25.627L160.708 12.3949H165.083L168.458 21.0633H168.512L171.402 12.3949H175.56L169.619 27.6523Z"
        fill="#044752"
      />
      <path
        d="M155.79 23.8717H155.736C155.286 24.5738 154.683 25.0779 153.927 25.384C153.189 25.69 152.406 25.843 151.577 25.843C150.965 25.843 150.371 25.753 149.795 25.573C149.237 25.411 148.742 25.1589 148.31 24.8169C147.878 24.4748 147.536 24.0518 147.284 23.5477C147.032 23.0436 146.906 22.4585 146.906 21.7924C146.906 21.0363 147.041 20.3972 147.311 19.8751C147.599 19.353 147.977 18.921 148.445 18.5789C148.931 18.2369 149.48 17.9758 150.092 17.7958C150.704 17.5978 151.334 17.4537 151.983 17.3637C152.649 17.2737 153.306 17.2197 153.954 17.2017C154.62 17.1837 155.232 17.1747 155.79 17.1747C155.79 16.4546 155.529 15.8875 155.007 15.4734C154.503 15.0414 153.9 14.8253 153.198 14.8253C152.532 14.8253 151.92 14.9693 151.361 15.2574C150.821 15.5274 150.335 15.9055 149.903 16.3916L147.743 14.1772C148.499 13.4751 149.381 12.953 150.389 12.611C151.397 12.2509 152.442 12.0709 153.522 12.0709C154.71 12.0709 155.682 12.2239 156.438 12.53C157.212 12.818 157.824 13.2501 158.275 13.8262C158.743 14.4023 159.067 15.1134 159.247 15.9595C159.427 16.7876 159.517 17.7508 159.517 18.849V25.519H155.79V23.8717ZM154.791 19.7671C154.485 19.7671 154.098 19.7851 153.63 19.8211C153.18 19.8391 152.739 19.9111 152.307 20.0371C151.893 20.1632 151.532 20.3522 151.226 20.6042C150.938 20.8563 150.794 21.2073 150.794 21.6574C150.794 22.1435 151.001 22.5035 151.415 22.7376C151.83 22.9716 152.262 23.0886 152.712 23.0886C153.108 23.0886 153.486 23.0346 153.846 22.9266C154.224 22.8186 154.557 22.6655 154.845 22.4675C155.133 22.2695 155.358 22.0174 155.52 21.7114C155.7 21.4053 155.79 21.0453 155.79 20.6312V19.7671H154.791Z"
        fill="#044752"
      />
      <path
        d="M131.058 6.4H138.16C139.15 6.4 140.086 6.49001 140.968 6.67004C141.85 6.85007 142.615 7.16512 143.264 7.61519C143.93 8.04725 144.452 8.64135 144.83 9.39747C145.226 10.1356 145.424 11.0717 145.424 12.2059C145.424 13.3221 145.244 14.2582 144.884 15.0143C144.524 15.7705 144.029 16.3736 143.399 16.8236C142.768 17.2737 142.021 17.5978 141.157 17.7958C140.293 17.9758 139.357 18.0658 138.349 18.0658H135.27V25.519H131.058V6.4ZM135.27 14.5013H138.079C138.457 14.5013 138.817 14.4653 139.159 14.3932C139.519 14.3212 139.834 14.2042 140.104 14.0422C140.392 13.8622 140.617 13.6281 140.779 13.3401C140.959 13.034 141.049 12.656 141.049 12.2059C141.049 11.7198 140.932 11.3328 140.698 11.0447C140.482 10.7387 140.194 10.5046 139.834 10.3426C139.492 10.1806 139.105 10.0816 138.673 10.0456C138.241 9.99156 137.827 9.96455 137.431 9.96455H135.27V14.5013Z"
        fill="#044752"
      />
      <path
        d="M124.276 23.8717H124.222C123.772 24.5738 123.169 25.0779 122.413 25.384C121.675 25.69 120.892 25.843 120.064 25.843C119.452 25.843 118.858 25.753 118.282 25.573C117.723 25.411 117.228 25.1589 116.796 24.8169C116.364 24.4748 116.022 24.0518 115.77 23.5477C115.518 23.0436 115.392 22.4585 115.392 21.7924C115.392 21.0363 115.527 20.3972 115.797 19.8751C116.085 19.353 116.463 18.921 116.931 18.5789C117.417 18.2369 117.966 17.9758 118.579 17.7958C119.191 17.5978 119.821 17.4537 120.469 17.3637C121.135 17.2737 121.792 17.2197 122.44 17.2017C123.106 17.1837 123.718 17.1747 124.276 17.1747C124.276 16.4546 124.015 15.8875 123.493 15.4734C122.989 15.0414 122.386 14.8253 121.684 14.8253C121.018 14.8253 120.406 14.9693 119.848 15.2574C119.308 15.5274 118.822 15.9055 118.39 16.3916L116.229 14.1772C116.985 13.4751 117.867 12.953 118.876 12.611C119.884 12.2509 120.928 12.0709 122.008 12.0709C123.196 12.0709 124.168 12.2239 124.925 12.53C125.699 12.818 126.311 13.2501 126.761 13.8262C127.229 14.4023 127.553 15.1134 127.733 15.9595C127.913 16.7876 128.003 17.7508 128.003 18.849V25.519H124.276V23.8717ZM123.277 19.7671C122.971 19.7671 122.584 19.7851 122.116 19.8211C121.666 19.8391 121.225 19.9111 120.793 20.0371C120.379 20.1632 120.019 20.3522 119.713 20.6042C119.425 20.8563 119.281 21.2073 119.281 21.6574C119.281 22.1435 119.488 22.5035 119.902 22.7376C120.316 22.9716 120.748 23.0886 121.198 23.0886C121.594 23.0886 121.972 23.0346 122.332 22.9266C122.71 22.8186 123.043 22.6655 123.331 22.4675C123.619 22.2695 123.844 22.0174 124.006 21.7114C124.186 21.4053 124.276 21.0453 124.276 20.6312V19.7671H123.277Z"
        fill="#044752"
      />
      <path
        d="M99.6577 12.3949H104.032L107.354 21.3063H107.408L110.486 12.3949H114.564L109.379 25.519H105.086L99.6577 12.3949Z"
        fill="#044752"
      />
      <path
        d="M84.6523 12.3949H89.027L92.3485 21.3063H92.4026L95.481 12.3949H99.5587L94.3739 25.519H90.0802L84.6523 12.3949Z"
        fill="#044752"
      />
      <path
        d="M82.9452 23.2506C82.2971 24.0788 81.4779 24.7179 80.4878 25.1679C79.4976 25.618 78.4715 25.843 77.4093 25.843C76.4011 25.843 75.447 25.681 74.5469 25.357C73.6647 25.0329 72.8906 24.5738 72.2245 23.9798C71.5764 23.3677 71.0633 22.6385 70.6853 21.7924C70.3072 20.9463 70.1182 20.0011 70.1182 18.957C70.1182 17.9128 70.3072 16.9677 70.6853 16.1215C71.0633 15.2754 71.5764 14.5553 72.2245 13.9612C72.8906 13.3491 73.6647 12.881 74.5469 12.557C75.447 12.2329 76.4011 12.0709 77.4093 12.0709C78.3455 12.0709 79.1916 12.2329 79.9477 12.557C80.7218 12.881 81.3699 13.3491 81.892 13.9612C82.4321 14.5553 82.8462 15.2754 83.1342 16.1215C83.4222 16.9677 83.5663 17.9128 83.5663 18.957V20.2262H74.1688C74.3308 21.0003 74.6819 21.6214 75.222 22.0895C75.762 22.5395 76.4282 22.7646 77.2203 22.7646C77.8864 22.7646 78.4445 22.6205 78.8945 22.3325C79.3626 22.0264 79.7677 21.6394 80.1097 21.1713L82.9452 23.2506ZM79.5156 17.4717C79.5336 16.7876 79.3086 16.2025 78.8405 15.7165C78.3725 15.2304 77.7694 14.9873 77.0312 14.9873C76.5812 14.9873 76.1851 15.0594 75.8431 15.2034C75.501 15.3474 75.204 15.5364 74.9519 15.7705C74.7179 15.9865 74.5289 16.2475 74.3848 16.5536C74.2588 16.8416 74.1868 17.1477 74.1688 17.4717H79.5156Z"
        fill="#044752"
      />
      <path
        d="M53.5259 6.4H60.925C61.8972 6.4 62.8153 6.49902 63.6795 6.69705C64.5616 6.87707 65.3267 7.19212 65.9748 7.64219C66.6409 8.07426 67.163 8.66835 67.5411 9.42447C67.9371 10.1626 68.1352 11.0897 68.1352 12.2059C68.1352 13.5561 67.7841 14.7083 67.082 15.6624C66.3799 16.5986 65.3537 17.1927 64.0035 17.4447L68.8643 25.519H63.8145L59.8179 17.8768H57.7385V25.519H53.5259V6.4ZM57.7385 14.3122H60.2229C60.601 14.3122 60.997 14.3032 61.4111 14.2852C61.8432 14.2492 62.2302 14.1682 62.5723 14.0422C62.9143 13.8982 63.1934 13.6821 63.4094 13.3941C63.6435 13.106 63.7605 12.701 63.7605 12.1789C63.7605 11.6928 63.6615 11.3058 63.4634 11.0177C63.2654 10.7297 63.0134 10.5136 62.7073 10.3696C62.4013 10.2076 62.0502 10.0996 61.6542 10.0456C61.2581 9.99156 60.871 9.96456 60.493 9.96456H57.7385V14.3122Z"
        fill="#044752"
      />
    </svg>
  );
}

export function CloudyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.603 3.799C9.02496 3.31223 9.54673 2.92196 10.1329 2.65468C10.719 2.38741 11.3558 2.24939 12 2.25C13.357 2.25 14.573 2.85 15.397 3.799C16.0397 3.75311 16.6847 3.84609 17.2883 4.07161C17.8919 4.29713 18.4399 4.64992 18.895 5.106C19.3509 5.56106 19.7036 6.10888 19.9291 6.71226C20.1546 7.31564 20.2477 7.96047 20.202 8.603C20.6886 9.02505 21.0787 9.54686 21.3458 10.133C21.6129 10.7191 21.7507 11.3559 21.75 12C21.7506 12.6442 21.6126 13.281 21.3453 13.8671C21.078 14.4533 20.6878 14.975 20.201 15.397C20.2467 16.0395 20.1536 16.6844 19.9281 17.2877C19.7026 17.8911 19.3499 18.4389 18.894 18.894C18.4389 19.3499 17.8911 19.7026 17.2877 19.9281C16.6844 20.1536 16.0395 20.2467 15.397 20.201C14.975 20.6878 14.4533 21.078 13.8671 21.3453C13.281 21.6126 12.6442 21.7506 12 21.75C11.3558 21.7506 10.719 21.6126 10.1329 21.3453C9.54673 21.078 9.02496 20.6878 8.603 20.201C7.96038 20.247 7.31538 20.1542 6.71181 19.9289C6.10824 19.7035 5.56023 19.3509 5.105 18.895C4.64897 18.4398 4.29622 17.8919 4.0707 17.2883C3.84518 16.6847 3.75218 16.0397 3.798 15.397C3.31141 14.9749 2.92133 14.4531 2.65423 13.867C2.38713 13.2809 2.24927 12.6441 2.25 12C2.25 10.643 2.85 9.427 3.799 8.603C3.75326 7.96047 3.8463 7.31562 4.07182 6.71222C4.29734 6.10883 4.65005 5.56103 5.106 5.106C5.56103 4.65005 6.10883 4.29734 6.71222 4.07182C7.31562 3.8463 7.96047 3.75326 8.603 3.799ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62136C15.7361 9.52257 15.7013 9.42783 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98222 14.9769 8.97992 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27226 12.5612 8.26883 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
        fill="#CB9A2B"
      />
    </svg>
  );
}

export const CardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M29.3333 28.3334C29.3333 28.88 28.88 29.3334 28.3333 29.3334H3.66666C3.12 29.3334 2.66666 28.88 2.66666 28.3334C2.66666 27.7867 3.12 27.3334 3.66666 27.3334H28.3333C28.88 27.3334 29.3333 27.7867 29.3333 28.3334Z"
        fill="#B4C8CB"
      />
      <path
        d="M20.52 6.02672L6.2 20.3467C5.65334 20.8934 4.77334 20.8934 4.24 20.3467H4.22667C2.37334 18.4801 2.37334 15.4667 4.22667 13.6134L13.76 4.08005C15.6267 2.21339 18.64 2.21339 20.5067 4.08005C21.0533 4.60005 21.0533 5.49339 20.52 6.02672Z"
        fill="#B4C8CB"
      />
      <path
        d="M27.76 11.32L23.6933 7.25338C23.1467 6.70672 22.2667 6.70672 21.7333 7.25338L7.41333 21.5734C6.86666 22.1067 6.86666 22.9867 7.41333 23.5334L11.48 27.6134C13.3467 29.4667 16.36 29.4667 18.2267 27.6134L27.7467 18.0801C29.64 16.2134 29.64 13.1867 27.76 11.32ZM17.0133 23.3601L15.4 24.9867C15.0667 25.32 14.52 25.32 14.1733 24.9867C13.84 24.6534 13.84 24.1067 14.1733 23.76L15.8 22.1334C16.12 21.8134 16.68 21.8134 17.0133 22.1334C17.3467 22.4667 17.3467 23.0401 17.0133 23.3601ZM22.3067 18.0667L19.0533 21.3334C18.72 21.6534 18.1733 21.6534 17.8267 21.3334C17.4933 21 17.4933 20.4534 17.8267 20.1067L21.0933 16.84C21.4133 16.5201 21.9733 16.5201 22.3067 16.84C22.64 17.1867 22.64 17.7334 22.3067 18.0667Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const RiskIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15 5.20005V17.2267C15 17.6667 14.7867 18.0667 14.4267 18.3201L4.81332 25.0534C4.02666 25.6001 2.90666 25.1734 2.73332 24.2267C2.53332 23.0801 2.79999 21.7334 3.59999 20.2801L7.75999 12.8001L11.68 5.74672C11.9867 5.20005 12.32 4.72005 12.6667 4.30672C13.4667 3.37338 15 3.97338 15 5.20005Z"
        fill="#B4C8CB"
      />
      <path
        d="M27.1867 25.0534L17.5733 18.3201C17.2133 18.0667 17 17.6667 17 17.2267V5.20005C17 3.97338 18.5333 3.37338 19.3333 4.30672C19.68 4.72005 20.0133 5.20005 20.32 5.74672L24.24 12.8001L28.4 20.2801C29.2 21.7334 29.4667 23.0801 29.2667 24.2267C29.0933 25.1734 27.9733 25.6001 27.1867 25.0534Z"
        fill="#B4C8CB"
      />
      <path
        d="M7.01337 25.52L15.2134 20.0534C15.6534 19.76 16.3734 19.76 16.8134 20.0534L25.0134 25.52C27.1867 26.9734 26.8267 28.16 24.2134 28.16H7.80004C5.20004 28.1467 4.84004 26.96 7.01337 25.52Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const BankingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M29.3334 25.3333V29.3333H2.66669V25.3333C2.66669 24.6 3.26669 24 4.00002 24H28C28.7334 24 29.3334 24.6 29.3334 25.3333Z"
        fill="#B4C8CB"
        stroke="#B4C8CB"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M9.33335 14.6666H6.66669V24H9.33335V14.6666Z" fill="#B4C8CB" />
      <path d="M14.6667 14.6666H12V24H14.6667V14.6666Z" fill="#B4C8CB" />
      <path d="M20 14.6666H17.3333V24H20V14.6666Z" fill="#B4C8CB" />
      <path d="M25.3334 14.6666H22.6667V24H25.3334V14.6666Z" fill="#B4C8CB" />
      <path
        d="M30.6666 30.3334H1.33331C0.786646 30.3334 0.333313 29.88 0.333313 29.3334C0.333313 28.7867 0.786646 28.3334 1.33331 28.3334H30.6666C31.2133 28.3334 31.6666 28.7867 31.6666 29.3334C31.6666 29.88 31.2133 30.3334 30.6666 30.3334Z"
        fill="#B4C8CB"
      />
      <path
        d="M28.4934 7.66662L16.4934 2.86662C16.2267 2.75995 15.7734 2.75995 15.5067 2.86662L3.50669 7.66662C3.04002 7.85329 2.66669 8.39995 2.66669 8.90662V13.3333C2.66669 14.0666 3.26669 14.6666 4.00002 14.6666H28C28.7334 14.6666 29.3334 14.0666 29.3334 13.3333V8.90662C29.3334 8.39995 28.96 7.85329 28.4934 7.66662ZM16 11.3333C14.8934 11.3333 14 10.44 14 9.33329C14 8.22662 14.8934 7.33329 16 7.33329C17.1067 7.33329 18 8.22662 18 9.33329C18 10.44 17.1067 11.3333 16 11.3333Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const AlternativeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15.92 2.94664L12.7067 10.4266H9.49332C8.95999 10.4266 8.43999 10.4666 7.93332 10.5733L9.26665 7.37331L9.31999 7.25331L9.39999 7.03998C9.43999 6.94665 9.46665 6.86664 9.50665 6.79998C11.0533 3.21331 12.7867 2.09331 15.92 2.94664Z"
        fill="#B4C8CB"
      />
      <path
        d="M24.9733 10.7867L24.9467 10.7733C24.1467 10.5467 23.3333 10.4267 22.5067 10.4267H14.16L17.16 3.45332L17.2 3.35999C17.3867 3.42665 17.5867 3.51999 17.7867 3.58665L20.7333 4.82665C22.3733 5.50665 23.52 6.21332 24.2267 7.06665C24.3467 7.22665 24.4533 7.37332 24.56 7.54665C24.68 7.73332 24.7733 7.91999 24.8267 8.11999C24.88 8.23999 24.92 8.34665 24.9467 8.46665C25.1467 9.14665 25.16 9.91999 24.9733 10.7867Z"
        fill="#B4C8CB"
      />
      <path
        d="M16.6933 23.5466H17.0267C17.4267 23.5466 17.76 23.1866 17.76 22.7466C17.76 22.1866 17.6 22.1066 17.2533 21.9733L16.6933 21.7733V23.5466Z"
        fill="#B4C8CB"
      />
      <path
        d="M24.3867 12.6933C23.7867 12.52 23.16 12.4266 22.5067 12.4266H9.49333C8.58666 12.4266 7.73333 12.6 6.93333 12.9466C4.61333 13.9466 2.98666 16.2533 2.98666 18.9333V21.5333C2.98666 21.8533 3.01333 22.16 3.05333 22.48C3.34666 26.72 5.61333 28.9866 9.85333 29.2666C10.16 29.3066 10.4667 29.3333 10.8 29.3333H21.2C26.1333 29.3333 28.7333 26.9866 28.9867 22.32C29 22.0666 29.0133 21.8 29.0133 21.5333V18.9333C29.0133 15.9866 27.0533 13.5066 24.3867 12.6933ZM17.7067 20.6666C18.32 20.88 19.1467 21.3333 19.1467 22.7466C19.1467 23.96 18.2 24.9333 17.0267 24.9333H16.6933V25.2266C16.6933 25.6133 16.3867 25.92 16 25.92C15.6133 25.92 15.3067 25.6133 15.3067 25.2266V24.9333H15.1867C13.9067 24.9333 12.8533 23.8533 12.8533 22.52C12.8533 22.1333 13.16 21.8266 13.5467 21.8266C13.9333 21.8266 14.24 22.1333 14.24 22.52C14.24 23.08 14.6667 23.5466 15.1867 23.5466H15.3067V21.2933L14.2933 20.9333C13.68 20.72 12.8533 20.2666 12.8533 18.8533C12.8533 17.64 13.8 16.6666 14.9733 16.6666H15.3067V16.3733C15.3067 15.9866 15.6133 15.68 16 15.68C16.3867 15.68 16.6933 15.9866 16.6933 16.3733V16.6666H16.8133C18.0933 16.6666 19.1467 17.7466 19.1467 19.08C19.1467 19.4666 18.84 19.7733 18.4533 19.7733C18.0667 19.7733 17.76 19.4666 17.76 19.08C17.76 18.52 17.3333 18.0533 16.8133 18.0533H16.6933V20.3066L17.7067 20.6666Z"
        fill="#B4C8CB"
      />
      <path
        d="M14.24 18.8533C14.24 19.4133 14.4 19.4933 14.7467 19.6267L15.3067 19.8267V18.0533H14.9733C14.56 18.0533 14.24 18.4133 14.24 18.8533Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const FraudIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M17.9867 17.84H14.6667C14.2667 17.84 13.9467 18.16 13.9467 18.56C13.9467 18.96 14.2667 19.28 14.6667 19.28H17.9867C18.3867 19.28 18.7067 18.96 18.7067 18.56C18.7067 18.16 18.3867 17.84 17.9867 17.84Z"
        fill="#B4C8CB"
      />
      <path
        d="M12.5867 17.84H10.92C10.52 17.84 10.2 18.16 10.2 18.56C10.2 18.96 10.52 19.28 10.92 19.28H12.5867C12.9867 19.28 13.3067 18.96 13.3067 18.56C13.3067 18.16 12.9867 17.84 12.5867 17.84Z"
        fill="#B4C8CB"
      />
      <path
        d="M24.72 5.62671L17.3867 2.88004C16.6267 2.60004 15.3867 2.60004 14.6267 2.88004L7.29333 5.62671C5.88 6.16004 4.73333 7.81338 4.73333 9.32004V20.12C4.73333 21.2 5.44 22.6267 6.30666 23.2667L13.64 28.7467C14.9333 29.72 17.0533 29.72 18.3467 28.7467L25.68 23.2667C26.5467 22.6134 27.2533 21.2 27.2533 20.12V9.32004C27.2667 7.81338 26.12 6.16004 24.72 5.62671ZM24.2267 18.2C24.2 20.96 23.44 21.6534 20.5733 21.6534H11.44C8.52 21.6534 7.78666 20.9334 7.78666 18.04V14.9334C7.78666 14.56 8.08 14.2667 8.45333 14.2667H23.56C23.9333 14.2667 24.2267 14.56 24.2267 14.9334V18.2ZM24.2267 12.1467C24.2267 12.52 23.9333 12.8134 23.56 12.8134H8.45333C8.08 12.8134 7.78666 12.52 7.78666 12.1467V11.2934C7.78666 8.68004 8.4 7.84004 10.68 7.69338C10.92 7.69338 11.1733 7.68004 11.44 7.68004H20.5733C23.4933 7.68004 24.2267 8.40004 24.2267 11.2934V12.1467Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const RoutingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M29.3333 20C29.3333 25.16 25.16 29.3333 20 29.3333L21.4 27"
        stroke="#B4C8CB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66663 12C2.66663 6.83996 6.83996 2.66663 12 2.66663L10.6 4.99996"
        stroke="#B4C8CB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.3333 5.59996V5.74663C29.3333 6.11996 29.04 6.41329 28.6667 6.41329H16.6667C16.2933 6.41329 16 6.11996 16 5.74663V5.59996C16 3.25329 16.5867 2.66663 18.96 2.66663H26.3733C28.7467 2.66663 29.3333 3.25329 29.3333 5.59996Z"
        fill="#B4C8CB"
      />
      <path
        d="M16.6667 7.7467C16.2933 7.7467 16 8.04004 16 8.41337V9.7467V11.0667C16 13.4134 16.5867 14 18.96 14H26.3733C28.7467 14 29.3333 13.4134 29.3333 11.0667V9.7467V8.41337C29.3333 8.04004 29.04 7.7467 28.6667 7.7467H16.6667Z"
        fill="#B4C8CB"
      />
      <path
        d="M16 20.9333V21.08C16 21.4533 15.7066 21.7467 15.3333 21.7467H3.33329C2.95996 21.7467 2.66663 21.4533 2.66663 21.08V20.9333C2.66663 18.5867 3.25329 18 5.62663 18H13.04C15.4133 18 16 18.5867 16 20.9333Z"
        fill="#B4C8CB"
      />
      <path
        d="M3.33329 23.08C2.95996 23.08 2.66663 23.3733 2.66663 23.7466V25.08V26.4C2.66663 28.7466 3.25329 29.3333 5.62663 29.3333H13.04C15.4133 29.3333 16 28.7466 16 26.4V25.08V23.7466C16 23.3733 15.7066 23.08 15.3333 23.08H3.33329Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const ProviderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M22.6667 4.66663H9.33335C5.33335 4.66663 2.66669 6.66663 2.66669 11.3333V20.6666C2.66669 25.3333 5.33335 27.3333 9.33335 27.3333H22.6667C26.6667 27.3333 29.3334 25.3333 29.3334 20.6666V11.3333C29.3334 6.66663 26.6667 4.66663 22.6667 4.66663ZM5.00002 11.3333C5.00002 8.94663 6.94669 6.99996 9.33335 6.99996H11.3334C11.88 6.99996 12.3334 7.45329 12.3334 7.99996C12.3334 8.54663 11.88 8.99996 11.3334 8.99996H9.33335C8.05335 8.99996 7.00002 10.0533 7.00002 11.3333V13.3333C7.00002 13.88 6.54669 14.3333 6.00002 14.3333C5.45335 14.3333 5.00002 13.88 5.00002 13.3333V11.3333ZM11.3334 25H9.33335C6.94669 25 5.00002 23.0533 5.00002 20.6666V18.6666C5.00002 18.12 5.45335 17.6666 6.00002 17.6666C6.54669 17.6666 7.00002 18.12 7.00002 18.6666V20.6666C7.00002 21.9466 8.05335 23 9.33335 23H11.3334C11.88 23 12.3334 23.4533 12.3334 24C12.3334 24.5466 11.88 25 11.3334 25ZM16 20C13.7867 20 12 18.2133 12 16C12 13.7866 13.7867 12 16 12C18.2134 12 20 13.7866 20 16C20 18.2133 18.2134 20 16 20ZM27 20.6666C27 23.0533 25.0534 25 22.6667 25H20.6667C20.12 25 19.6667 24.5466 19.6667 24C19.6667 23.4533 20.12 23 20.6667 23H22.6667C23.9467 23 25 21.9466 25 20.6666V18.6666C25 18.12 25.4534 17.6666 26 17.6666C26.5467 17.6666 27 18.12 27 18.6666V20.6666ZM27 13.3333C27 13.88 26.5467 14.3333 26 14.3333C25.4534 14.3333 25 13.88 25 13.3333V11.3333C25 10.0533 23.9467 8.99996 22.6667 8.99996H20.6667C20.12 8.99996 19.6667 8.54663 19.6667 7.99996C19.6667 7.45329 20.12 6.99996 20.6667 6.99996H22.6667C25.0534 6.99996 27 8.94663 27 11.3333V13.3333Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const GatewayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M21.5867 2.66663H10.4133C5.55999 2.66663 2.66666 5.55996 2.66666 10.4133V21.5733C2.66666 26.44 5.55999 29.3333 10.4133 29.3333H21.5733C26.4267 29.3333 29.32 26.44 29.32 21.5866V10.4133C29.3333 5.55996 26.44 2.66663 21.5867 2.66663ZM25.3333 10.9866C25.3333 11.72 24.7333 12.32 24 12.32H21.3333C20.7867 12.32 20.3333 12.7733 20.3333 13.32C20.3333 13.88 20.7867 14.32 21.3333 14.32H24C24.7333 14.32 25.3333 14.92 25.3333 15.6533V16.3333C25.3333 17.0666 24.7333 17.6666 24 17.6666H21.3333C20.7867 17.6666 20.3333 18.12 20.3333 18.6666C20.3333 19.2133 20.7867 19.6666 21.3333 19.6666H24C24.7333 19.6666 25.3333 20.2666 25.3333 21V21.3333C25.3333 23.5466 23.5467 25.3333 21.3333 25.3333H10.6667C8.45332 25.3333 6.66666 23.5466 6.66666 21.3333V20.6666C6.66666 19.9333 7.26666 19.3333 7.99999 19.3333H9.97332C11.9333 19.3333 13.4933 17.6533 13.2933 15.6533C13.12 13.92 11.5333 12.6666 9.78666 12.6666H7.99999C7.26666 12.6666 6.66666 12.0666 6.66666 11.3333V10.6666C6.66666 8.45329 8.45332 6.66663 10.6667 6.66663H21.3333C23.5467 6.66663 25.3333 8.45329 25.3333 10.6666V10.9866ZM6.66666 16C6.66666 15.2666 7.26666 14.6666 7.99999 14.6666H9.33332C10.0667 14.6666 10.6667 15.2666 10.6667 16C10.6667 16.7333 10.0667 17.3333 9.33332 17.3333H7.99999C7.26666 17.3333 6.66666 16.7333 6.66666 16Z"
        fill="#B4C8CB"
      />
    </svg>
  );
};

export const RatingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.788 3.21009C11.236 2.13309 12.764 2.13309 13.212 3.21009L15.294 8.21709L20.698 8.65009C21.862 8.74309 22.334 10.1951 21.447 10.9551L17.33 14.4821L18.587 19.7551C18.858 20.8911 17.623 21.7881 16.627 21.1801L12 18.3541L7.373 21.1801C6.377 21.7881 5.142 20.8901 5.413 19.7551L6.67 14.4821L2.553 10.9551C1.666 10.1951 2.138 8.74309 3.302 8.65009L8.706 8.21709L10.788 3.21009Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AccordionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M13 9V17M17 13H9M25 13C25 14.5759 24.6896 16.1363 24.0866 17.5922C23.4835 19.0481 22.5996 20.371 21.4853 21.4853C20.371 22.5996 19.0481 23.4835 17.5922 24.0866C16.1363 24.6896 14.5759 25 13 25C11.4241 25 9.86371 24.6896 8.4078 24.0866C6.95189 23.4835 5.62902 22.5996 4.51472 21.4853C3.40042 20.371 2.5165 19.0481 1.91345 17.5922C1.31039 16.1363 1 14.5759 1 13C1 9.8174 2.26428 6.76516 4.51472 4.51472C6.76516 2.26428 9.8174 1 13 1C16.1826 1 19.2348 2.26428 21.4853 4.51472C23.7357 6.76516 25 9.8174 25 13Z"
        stroke="#044752"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BurgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0.75C0 0.551088 0.0790175 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H17.25C17.4489 0 17.6397 0.0790175 17.7803 0.21967C17.921 0.360322 18 0.551088 18 0.75C18 0.948912 17.921 1.13968 17.7803 1.28033C17.6397 1.42098 17.4489 1.5 17.25 1.5H0.75C0.551088 1.5 0.360322 1.42098 0.21967 1.28033C0.0790175 1.13968 0 0.948912 0 0.75ZM0 6C0 5.80109 0.0790175 5.61032 0.21967 5.46967C0.360322 5.32902 0.551088 5.25 0.75 5.25H17.25C17.4489 5.25 17.6397 5.32902 17.7803 5.46967C17.921 5.61032 18 5.80109 18 6C18 6.19891 17.921 6.38968 17.7803 6.53033C17.6397 6.67098 17.4489 6.75 17.25 6.75H0.75C0.551088 6.75 0.360322 6.67098 0.21967 6.53033C0.0790175 6.38968 0 6.19891 0 6ZM0 11.25C0 11.0511 0.0790175 10.8603 0.21967 10.7197C0.360322 10.579 0.551088 10.5 0.75 10.5H17.25C17.4489 10.5 17.6397 10.579 17.7803 10.7197C17.921 10.8603 18 11.0511 18 11.25C18 11.4489 17.921 11.6397 17.7803 11.7803C17.6397 11.921 17.4489 12 17.25 12H0.75C0.551088 12 0.360322 11.921 0.21967 11.7803C0.0790175 11.6397 0 11.4489 0 11.25Z"
        fill="#044752"
      />
    </svg>
  );
};
